import { render, staticRenderFns } from "./s-info-montant.vue?vue&type=template&id=2cfaef71&scoped=true"
import script from "./s-info-montant.vue?vue&type=script&setup=true&lang=js"
export * from "./s-info-montant.vue?vue&type=script&setup=true&lang=js"
import style0 from "./s-info-montant.vue?vue&type=style&index=0&id=2cfaef71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfaef71",
  null
  
)

export default component.exports